import Vue from 'vue';
export default Vue.extend({
    props: {
        followed: {
            type: Boolean,
            required: true,
        },
    },
    methods: {
        onClick() {
            this.$emit('subscribe-thread', !this.followed);
        },
    },
});
